import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import HubPageLayout from '../components/HubPageLayout';
import FramedPanel from '../components/FramedPanel';
import { PODCASTS } from './data/podcasts';

// Av Library / Podcast — "Listen and learn": framed section hero over the
// podcast channel list (cover art, abstract, host, outbound listen link).
//
// Deep link from the Av Library dropdown elsewhere in the hub:
// /dashboard/av-library/podcast?podcast=<slug> scrolls to that channel and
// highlights it. Episodes play on the publisher's own site, so there is no
// in-app player to launch — the outbound "listen" link is the play action.
const PodcastPage = () => {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get('podcast');
  const refs = useRef({});

  useEffect(() => {
    if (!requested) return;
    const el = refs.current[requested];
    if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, [requested]);

  return (
    <HubPageLayout>
      <FramedPanel title="Listen and learn">
        <div className="px-6 pt-8 pb-6">
          <img
            src="/images/av-library/listen-and-learn-hero.jpeg"
            alt=""
            className="w-full h-[300px] object-cover"
          />
        </div>
      </FramedPanel>

      {/* The third-party disclaimer sits at the foot of the page only (10-28). */}

      <div className="mt-8">
        {PODCASTS.map((podcast, index) => {
          const isTarget = podcast.slug === requested;
          return (
            <div key={podcast.slug} ref={(el) => { refs.current[podcast.slug] = el; }}>
              <div
                className={`flex flex-col sm:flex-row gap-6 sm:gap-8 py-8 items-start transition-colors ${
                  isTarget ? 'bg-[#E4F0F8] -mx-4 px-4 rounded-lg' : ''
                }`}
              >
                <div className="w-40 h-40 flex-shrink-0 overflow-hidden shadow-md">
                  <img src={podcast.image} alt={podcast.title} className="w-full h-full object-cover" />
                </div>

                <div className="flex-1 min-w-0">
                  <h2 className="text-base font-bold text-black mb-2">Abstract</h2>
                  <p className="text-black leading-relaxed">{podcast.abstract}</p>
                  <p className="text-gray-500 mt-4">
                    {podcast.hostLabel} &ndash; {podcast.hostName}
                  </p>
                  <a
                    href={podcast.listenUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 mt-3 transition-colors"
                  >
                    <span className="mr-1">&rarr;</span> listen
                  </a>
                </div>
              </div>

              {index < PODCASTS.length - 1 && <hr className="border-gray-300" />}
            </div>
          );
        })}
      </div>

      <p className="text-sm text-gray-500 mt-8 leading-relaxed">
        Disclaimer &ndash; These podcasts are offered for informational or entertainment purposes only.
        NuVola AI was not part of their development and takes no responsibility for the accuracy of
        their content.
      </p>
    </HubPageLayout>
  );
};

export default PodcastPage;
